import React, {useEffect, useState} from 'react';
import 'moment/locale/tr';
import {Col, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row} from 'reactstrap';
import {showAxiosError} from "../../../helper/helper";
import {request} from "../../../helper/APIUtils";
import DefaultModal from "../../invoice/DefaultModal";
import Alert from "react-s-alert";
import ReactLoadingTop from "../../../components/ReactLoadingTop";

const TrendyolSendMultipleModal = (props) => {

    const [error, setError] = useState({});
    const [process, setProcess] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [shipmentData, setShipmentData] = useState(null);
    const [istisnaModal, setIstisnaModal] = useState(false);
    const [istisnaStatus, setIstisnaStatus] = useState(null);
    const [sendLoading, setSendLoading] = useState(false);
    const [recordIds, setRecordIds] = useState([]);
    const [xslts, setXslts] = useState([]);
    const [index, setIndex] = useState(0);
    const [realIndex, setRealIndex] = useState(0);
    const [sendType, setSendType] = useState(null);
    const [status, setStatus] = useState("pause");
    const [defaultStatus, setDefaultStatus] = useState("success");
    const [statusText, setStatusText] = useState("Gönderim Bekliyor...");

    const statusTrendyol = (status) => {
        switch (status) {
            case 'Created':
                return 'Yeni Oluşan Sipariş';
            case 'Awaiting':
                return 'Askıda Olan Sipariş';
            case 'Picking':
                return 'Gönderime Hazırlanan Sipariş';
            case 'Invoiced':
                return 'Faturalı Sipariş';
            case 'Shipped':
                return 'Taşıma Durumunda Olan Sipariş';
            case 'AtCollectionPoint':
                return 'PUDO Noktasında Olan Sipariş';
            case 'Cancelled':
                return 'İptal Edilen Sipariş';
            case 'UnPacked':
                return 'Paketi Bölünmüş Sipariş';
            case 'Delivered':
                return 'Teslim Edilen Siparişler';
            case 'UnDelivered':
                return 'Teslim Edilemeyen Siparişler';
            case 'UnDeliveredAndReturned':
                return 'Geri Dönen Siparişler';
            default :
                return '';
        }
    }


    useEffect(() => {
        setRecordIds(props.recordIds);
        setSendType(props.sendType);
    }, [props.recordIds, props.sendType]);

    useEffect(() => {

    }, [statusText]);


    const validateField = (e) => {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let result = validateField(rule, boundary, e.target.value);
        let errorValue = { ...error };
        errorValue = Object.assign(errorValue, {[id]: result});
        setError(errorValue);
    }

    const sendTrendyolData = async () => {
        let trendyolData = [...props.recordIds];

        trendyolData = trendyolData.filter(item => item && item.invoiceLink == null);

        if (trendyolData.length === 0) {
            Alert.warning('Tüm dokümanlar gönderildi.', {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
            return;
        }

        for (let i = 0; i < trendyolData.length; i++) {
            let document = trendyolData[i];
            await istisnaCheck(document, i);
        }
    };

    const istisnaCheck = async (item, index) => {
        const istisna = item.lines.find(f => f.vatBaseAmount === 0);

        if (istisna !== undefined && istisna !== null) {
            setIstisnaModal(true);
            setShipmentData(item);
        } else {
            await trendyolDataToInvoiceData(item, index);
        }
    }

    const trendyolDataToInvoiceData = async (item, index) => {
        setSendLoading(true);
        let params = {
            url: '/trendyol/pazaryeri/createInvoice/' + 0,
            method: "post",
            data: item
        }
        setStatusText("Gönderiliyor...");
        setStatus("processing");
        try {
            const response = await request(params);
            Alert.success(response.data, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000,
                html: false
            });
            setStatusText("Gönderim Başarılı");
            setStatus("success");
        } catch (err) {
            setStatusText("Gönderim Başarısız");
            setStatus("error");
            showAxiosError(err);
        } finally {
            setSendLoading(false);
        }
    }

    const sendIstisnaData = (istisnaCode) => {
        setSendLoading(true);
        let params = {
            url: '/trendyol/pazaryeri/createInvoice/' + istisnaCode,
            method: "post",
            data: shipmentData
        }

        request(params)
            .then((response) => {
                Alert.success(response.data, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000,
                    html: false
                });
                setSendLoading(false);
            }).catch((err) => {
            showAxiosError(err)
            setSendLoading(false);
        })
        setIstisnaStatus(null)
    }

    const toDateTime = (time) => {
        const newTime = new Intl.DateTimeFormat('tr-TR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).format(time);

        const [day, month, year] = newTime.split('.');
        return `${day}-${month}-${year}`;
    }

    const onCancel = () => {
        if (index > 0) {
            props.toggleModal(false, true);
        } else {
            props.toggleModal(false, false);
        }
    }

    const btnActiveControl = (recordIds) => {
        let filteredRecords = [...recordIds];

        filteredRecords = filteredRecords.filter(item => item && item.invoiceLink == null);

        return filteredRecords.length === 0 ? true : false;
    };

    const getStatusRender = (currentStatus) => {
        let className =(currentStatus === "processing" ? "spinner fa-spin" : (currentStatus==="success" ? "check" :(currentStatus==="error" ? "close":"pause")));
        let color= (currentStatus === "processing" ? "dark" : (currentStatus==="success" ? "green" :(currentStatus==="error" ? "red":"dark")));
        return (<i className={"fas fa-" + className} style={{color:color,paddingRight:"4px"}}></i>);

    }

    const getStatus = (record) => {
        return record.invoiceLink ? "success" : "pause";
    }

    return (
        <DefaultModal
            isOpen={props.modal}
            disabled={btnDisabled || btnActiveControl(props.recordIds, index)}
            title={props.title}
            size="lg"
            modalBodyStyle={{padding: "0", minHeight: "500px"}}
            confirmBtnText="Toplu Gönder"
            cancelBtnText="İptal"
            onConfirm={(e) => sendTrendyolData(index)}
            onCancel={onCancel}>
            <Row>
                <Col sm="12">
                    <div>
                        <div className="card-body">
                            <Row>
                                <Col sm="12" style={{paddingRight: '5px', maxHeight: '500px', overflow: "auto"}}>
                                    <table className="" style={{textAlign: 'center', paddingBottom: "5px"}}>
                                        <thead>
                                        <tr style={{backgroundColor: '#ebedf0'}}>
                                            <th>#</th>
                                            <th>Sipariş Numarası</th>
                                            <th>Sipariş Tarihi</th>
                                            <th>Fatura Tutarı</th>
                                            <th>Durumu</th>
                                            <th>Gönderim Durumu</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {props.recordIds && props.recordIds .map((record, index) => {
                                            return (
                                                <tr key={index + "_" + record.id}
                                                    style={{backgroundColor: (record.id && getStatus(record) === "success" ? "lightgreen" : "")}}>
                                                    <td style={{margin: "0px"}}>{realIndex + (index + 1)}</td>
                                                    <td style={{margin: "0px"}}>{record.orderNumber}</td>
                                                    <td style={{margin: "0px"}}>{toDateTime(record.orderDate)}</td>
                                                    <td style={{margin: "0px"}}>{record.totalPrice + " TRY"}</td>
                                                    <td style={{margin: "0px"}}>{statusTrendyol(record.status)}</td>
                                                    <td style={{margin: "0px"}}>{record.invoiceLink ? getStatusRender(defaultStatus) : getStatusRender(status)}{record.invoiceLink ? "Gönderildi" : statusText}</td>
                                                </tr>
                                            )}
                                        )}
                                        {!process && (props.recordIds && props.recordIds.length === 0) &&
                                            <tr>
                                                <td colSpan="8">Kayıt bulunamadı</td>
                                            </tr>
                                        }
                                        {process &&
                                            <tr>
                                                <td colSpan="8">Doküman işleniyor...</td>
                                            </tr>
                                        }
                                        </tbody>
                                    </table>
                                </Col>
                                <Col sm="12">
                                    <p style={{float: "right"}}>Toplam Doküman
                                        Adeti: {props.recordIds ? props.recordIds.length : 0}</p>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>
            </Row>
            {sendLoading && <ReactLoadingTop style={{width: '90px', height: '90px'}}/>}
            <Modal isOpen={istisnaModal} size="md">
                <ModalHeader
                    className="justify-content-center">
                    İstisna Durum Bilgileri
                </ModalHeader>
                <ModalBody>
                    <div>
                        <FormGroup row style={{textAlign: 'center'}}>
                            <Label sm={12} for="formattedName" style={{fontWeight: 'bold', fontSize: '16px'}}>Lütfen
                                istisna durum bilgilerinizi doldurunuz.</Label>
                        </FormGroup>
                        <FormGroup row>
                            <Label sm={4} for="username">İstisna Durumu: *</Label>
                            <Col sm={8}>
                                <Input
                                    type="select"
                                    name="istisnaDurumu"
                                    value={istisnaStatus}
                                    onChange={e => {
                                        setIstisnaStatus(e.target.value);
                                        setIstisnaModal(false);
                                        sendIstisnaData(e.target.value);
                                    }}
                                >
                                    <option value="">Seçiniz</option>
                                    <option value="350">İstisna Diğer</option>
                                    <option value="351">İstisna Olmayan Diğer</option>
                                </Input>
                            </Col>
                        </FormGroup>
                    </div>
                </ModalBody>
            </Modal>
        </DefaultModal>
    );
}

export default TrendyolSendMultipleModal;